import { gql } from '@apollo/client';

export const PENALTY_HOST = gql`
  mutation penaltyHost($input: PenaltyHostInput!) {
    penaltyHost(input: $input) {
      id
      group_id
    }
  }
`;
